import { toast } from 'react-toastify'

import DI from '../../app/di'
import { Creative, CreativeAction } from '../../interfaces/entities/creative'
import { ICreativeService } from '../../interfaces/services/creatives'
import { on } from '../listener'
import * as actions from './actions'

export const commands = {
  goToCreativeOrProject: (
    creative: Creative,
    newCreative: Creative,
    creativeAction: CreativeAction,
  ) => {
    if (creative.project && creativeAction.name === 'delete') {
      const history = DI.get('history')
      const url = `/project/${creative.project.id}`
      history.push(url)
    }
    if (creativeAction.name === 'duplicate') {
      const history = DI.get('history')
      history.push(`/creatives/${newCreative.id}`)
    }
  },
}

const creativeService = () => DI.get('CreativeService') as ICreativeService

on(actions.getCreative, async (action, api) => {
  api.dispatch(
    actions.getCreativeComplete(
      await creativeService().getCreative(action.payload),
    ),
  )
})

on(actions.doCreativeAction, async (action, api) => {
  api.dispatch(
    actions.doCreativeActionComplete(
      await creativeService().doCreativeAction(
        action.payload.action,
        action.payload.creative,
      ),
    ),
  )
})

on(actions.doCreativeActionComplete, (action, api) => {
  // The creative the reducer was called with, i.e. the one the command
  // arguments used to close over.
  const creative = api.getOriginalState().creative.creative

  if (action.payload.type !== 'success') {
    toast.error(action.payload.payload.message, { autoClose: false })
    return
  }

  const newCreative = action.payload.payload.creative
  const creativeAction = action.payload.payload.action

  toast.success(action.payload.payload.message)

  if (creative == null) {
    return
  }

  if (creativeAction.name === 'delete' || creativeAction.name === 'duplicate') {
    commands.goToCreativeOrProject(creative, newCreative, creativeAction)
  } else {
    api.dispatch(actions.getCreative(creative.id))
  }
})

on(actions.setCreativeComment, async (action, api) => {
  api.dispatch(
    actions.setCreativeCommentComplete(
      await creativeService().setCreativeComment(
        action.payload.creativeId,
        action.payload.comment,
      ),
    ),
  )
})
